export const SHOULD_DISPLAY_ICON = true;
export const SHOULD_USE_SECONDARY_VARIANT = true;
export const POINTS_TRANSLATION_KEY = 'crowns';
export const ONLY_SHOW_REDEEM_REWARD_IN_RESTAURANT_CTA = '';
export const REDEEM_REWARD_TRANSLATION_KEY = 'redeemCtaText';
